import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getMyTrainingDashboard(token) {
  const res = await axios.get(`${API}/training/me`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getTrainingModuleDetail(moduleId, token) {
  const res = await axios.get(`${API}/training/modules/${moduleId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function setLessonComplete(lessonId, completed, token) {
  const res = await axios.post(
    `${API}/training/lessons/${lessonId}/complete`,
    { completed: Boolean(completed) },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function acknowledgeModule(moduleId, token) {
  const res = await axios.post(
    `${API}/training/modules/${moduleId}/acknowledge`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function submitModuleQuiz(moduleId, payload, token) {
  const res = await axios.post(
    `${API}/training/modules/${moduleId}/quiz/submit`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function listTrainingCategories(token) {
  const res = await axios.get(`${API}/training/categories`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createTrainingCategory(payload, token) {
  const res = await axios.post(`${API}/training/categories`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateTrainingCategory(categoryId, payload, token) {
  const res = await axios.put(`${API}/training/categories/${categoryId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteTrainingCategory(categoryId, token) {
  const res = await axios.delete(`${API}/training/categories/${categoryId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listTrainingModules(token) {
  const res = await axios.get(`${API}/training/modules`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createTrainingModule(payload, token) {
  const res = await axios.post(`${API}/training/modules`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateTrainingModule(moduleId, payload, token) {
  const res = await axios.put(`${API}/training/modules/${moduleId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function publishTrainingModule(moduleId, token) {
  const res = await axios.post(
    `${API}/training/modules/${moduleId}/publish`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function unpublishTrainingModule(moduleId, token) {
  const res = await axios.post(
    `${API}/training/modules/${moduleId}/unpublish`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function createTrainingLesson(moduleId, payload, token) {
  const res = await axios.post(
    `${API}/training/modules/${moduleId}/lessons`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateTrainingLesson(lessonId, payload, token) {
  const res = await axios.put(`${API}/training/lessons/${lessonId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteTrainingLesson(lessonId, token) {
  const res = await axios.delete(`${API}/training/lessons/${lessonId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function uploadLessonFile(lessonId, file, token) {
  const authToken = token || null;
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(
    `${API}/training/lessons/${lessonId}/upload`,
    formData,
    {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined,
    }
  );
  return res.data;
}

export async function deleteLessonDocument(lessonId, token) {
  const res = await axios.delete(`${API}/training/lessons/${lessonId}/document`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getTrainingLessonDocumentBlob(lessonId, token) {
  const authToken = token || null;
  const res = await axios.get(`${API}/training/lessons/${lessonId}/document`, {
    responseType: "blob",
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined,
  });
  return res.data;
}

export async function fetchLessonDocument(lessonId, token) {
  const authToken = token || null;
  const res = await axios.get(`${API}/training/lessons/${lessonId}/document`, {
    responseType: "blob",
    headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined,
  });
  return res;
}

export async function upsertTrainingAssignment(payload, token) {
  const res = await axios.post(`${API}/training/assignments/upsert`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listTrainingAssignments(params = {}, token) {
  const res = await axios.get(`${API}/training/assignments`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getStaffTrainingSummary(userId, token) {
  const res = await axios.get(`${API}/training/staff/${userId}/summary`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function upsertUserAssignment(payload, token) {
  const { userId, moduleId, assigned_on, due_on, priority, is_required } = payload || {};
  const res = await axios.post(
    `${API}/training/assignments/upsert`,
    {
      module_id: moduleId,
      target_type: "user",
      target_user_id: userId,
      assigned_on,
      due_on,
      priority,
      is_required,
    },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateTrainingAssignment(assignmentId, payload, token) {
  const res = await axios.put(
    `${API}/training/assignments/${assignmentId}`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function deleteTrainingAssignment(assignmentId, token) {
  const res = await axios.delete(`${API}/training/assignments/${assignmentId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteAssignment(assignmentId, token) {
  return deleteTrainingAssignment(assignmentId, token);
}

export async function getTrainingSettings(token) {
  const res = await axios.get(`${API}/training/settings`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateTrainingSettings(payload, token) {
  const res = await axios.put(`${API}/training/settings`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getTrainingAdminOverview(params = {}, token) {
  const res = await axios.get(`${API}/training/admin/overview`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listTrainingUsers(token) {
  const res = await axios.get(`${API}/training/admin/users`, {
    headers: authHeaders(token),
  });
  return res.data;
}
